import type { Namespace } from '../types';

// Ecommerce/Sales (R-075/D-078 — ECOM ch. 23). DE drafted — queued for review.
export const ecommerce = {
  title: { de: 'Sales', en: 'Sales' },
  desc: {
    de: 'Forward Capacity verkaufen: Katalog, Verfügbarkeit aus der Produktionsplanung, Aufträge → Produktionsbedarf (make-to-order).',
    en: 'Sell forward capacity: catalogue, availability from production planning, orders → production demand (make-to-order).',
  },

  tabOrders: { de: 'Aufträge', en: 'Orders' },
  tabAvailability: { de: 'Verfügbarkeit', en: 'Availability' },
  tabCatalogue: { de: 'Katalog', en: 'Catalogue' },
  tabCustomers: { de: 'Kunden', en: 'Customers' },

  // Status (STO-OM-002)
  stDraft: { de: 'Entwurf', en: 'Draft' },
  stConfirmed: { de: 'Bestätigt', en: 'Confirmed' },
  stInFulfilment: { de: 'In Erfüllung', en: 'In fulfilment' },
  stShipped: { de: 'Versendet', en: 'Shipped' },
  stDelivered: { de: 'Zugestellt', en: 'Delivered' },
  stCancelled: { de: 'Storniert', en: 'Cancelled' },

  colOrder: { de: 'Auftrag', en: 'Order' },
  colStatus: { de: 'Status', en: 'Status' },
  filterAll: { de: 'Alle', en: 'All' },
  colActions: { de: 'Aktionen', en: 'Actions' },
  customer: { de: 'Kunde', en: 'Customer' },
  product: { de: 'Produkt', en: 'Product' },
  qty: { de: 'Menge', en: 'Qty' },
  window: { de: 'Lieferfenster', en: 'Delivery window' },
  sku: { de: 'SKU', en: 'SKU' },
  units: { de: 'Einheiten', en: 'Units' },
  note: { de: 'Notiz', en: 'Note' },
  deliverFrom: { de: 'Lieferung von', en: 'Deliver from' },
  deliverTo: { de: 'Lieferung bis', en: 'Deliver to' },
  contact: { de: 'Kontakt', en: 'Contact' },
  address: { de: 'Adresse', en: 'Address' },
  active: { de: 'Aktiv', en: 'Active' },
  inactive: { de: 'Inaktiv', en: 'Inactive' },
  crop: { de: 'Kultur', en: 'Crop' },
  skuCode: { de: 'SKU-Code', en: 'SKU code' },
  nameDe: { de: 'Name (DE)', en: 'Name (DE)' },
  nameEn: { de: 'Name (EN)', en: 'Name (EN)' },
  packageG: { de: 'Gebinde (g)', en: 'Package (g)' },
  price: { de: 'Preis', en: 'Price' },
  priceAed: { de: 'Preis (AED)', en: 'Price (AED)' },
  minOrder: { de: 'Mindestbestellung', en: 'Min order' },
  shelfLife: { de: 'Haltbarkeit', en: 'Shelf life' },

  newOrder: { de: 'Neuer Auftrag', en: 'New Order' },
  newSku: { de: 'Neue SKU', en: 'New SKU' },
  editSku: { de: 'SKU bearbeiten', en: 'Edit SKU' },
  newCustomer: { de: 'Neuer Kunde', en: 'New Customer' },
  editCustomer: { de: 'Kunde bearbeiten', en: 'Edit customer' },
  createDraft: { de: 'Entwurf anlegen', en: 'Create draft' },
  confirm: { de: 'Bestätigen', en: 'Confirm' },
  save: { de: 'Speichern', en: 'Save' },

  pickSku: { de: 'SKU wählen …', en: 'Pick a SKU …' },
  availabilityHint: {
    de: 'SKU wählen — die Verfügbarkeit wird live aus der Produktionsplanung berechnet (kein Overbooking).',
    en: 'Pick a SKU — availability is computed live from production planning (no over-booking).',
  },
  availLine: { de: 'Verfügbar in diesem Fenster: {kg} kg', en: 'Available in this window: {kg} kg' },
  availExceeds: {
    de: 'Anfrage übersteigt die Verfügbarkeit — Bestätigung wird abgelehnt.',
    en: 'request exceeds availability — confirmation will be rejected.',
  },
  notSellable: {
    de: 'Für die Kultur dieser SKU existiert kein aktiver Anbauzyklus — nicht verkaufbar.',
    en: "No enabled cultivation cycle exists for this SKU's crop — not sellable.",
  },
  catalogueHint: {
    de: 'Verkaufbare Produkte je Kultur — Preise/Werte sind Geschäftsdaten (Workshop).',
    en: 'Sellable products per crop — prices/values are business data (workshop).',
  },
  customersHint: {
    de: 'Minimale Gegenparteien für L1-Aufträge — Käufer-Organisationen kommen mit dem Shop.',
    en: 'Minimal counterparties for L1 orders — buyer organisations arrive with the shop.',
  },
  ordersEmpty: { de: 'Keine Aufträge.', en: 'No orders.' },
  catalogueEmpty: { de: 'Keine SKUs.', en: 'No SKUs.' },
  customersEmpty: { de: 'Keine Kunden.', en: 'No customers.' },

  toastCreated: { de: '{code} als Entwurf angelegt.', en: '{code} created as draft.' },
  toastConfirmed: {
    de: '{code} bestätigt — Produktionsbedarf übergeben.',
    en: '{code} confirmed — production demand handed over.',
  },
  toastCancelled: { de: 'Auftrag storniert.', en: 'Order cancelled.' },
  toastSkuSaved: { de: 'SKU gespeichert.', en: 'SKU saved.' },
  toastCustomerSaved: { de: 'Kunde gespeichert.', en: 'Customer saved.' },

  // Field placeholders
  phCustomer: { de: 'Kunde wählen', en: 'Select a customer' },
  phSku: { de: 'Produkt (SKU) wählen', en: 'Select a product (SKU)' },
  phUnits: { de: 'z. B. 10', en: 'e.g. 10' },
  phNote: { de: 'Optionale Notiz', en: 'Optional note' },
  phSkuCode: { de: 'z. B. MG-PEA-100', en: 'e.g. MG-PEA-100' },
  phCrop: { de: 'Kultur wählen', en: 'Select a crop' },
  phNameDe: { de: 'z. B. Erbsensprossen 100 g', en: 'e.g. Erbsensprossen 100 g' },
  phNameEn: { de: 'z. B. Pea shoots 100 g', en: 'e.g. Pea shoots 100 g' },
  phGrams: { de: 'z. B. 100', en: 'e.g. 100' },
  phPrice: { de: 'z. B. 12,50', en: 'e.g. 12.50' },
  phMinUnits: { de: 'z. B. 1', en: 'e.g. 1' },
  phShelf: { de: 'z. B. 7', en: 'e.g. 7' },
  phCustomerName: { de: 'z. B. Spinneys Jumeirah', en: 'e.g. Spinneys Jumeirah' },
  phContact: { de: 'Telefon oder E-Mail', en: 'Phone or email' },
  phAddress: { de: 'Straße, Gebäude, Stadt', en: 'Street, building, city' },

  filterStatus: { de: 'Status', en: 'Status' },
  windowInvalid: {
    de: 'Das Lieferende muss nach dem Beginn liegen.',
    en: 'Deliver-to must not be before deliver-from.',
  },
  confirmOrderTitle: { de: '{code} bestätigen?', en: 'Confirm {code}?' },
  confirmOrderMsg: {
    de: 'Die Bestätigung übergibt einen Produktionsbedarf an Farming Operations.',
    en: 'Confirming hands a production demand to Farming Operations.',
  },
  cancelOrderTitle: { de: '{code} stornieren?', en: 'Cancel {code}?' },
  cancelOrderMsg: {
    de: 'Der Auftrag wird storniert; ein noch offener Produktionsbedarf wird mit storniert. Das lässt sich nicht rückgängig machen.',
    en: 'The order is cancelled, and its production demand with it while that is still open. This cannot be undone.',
  },
  cancelOrderConfirm: { de: 'Auftrag stornieren', en: 'Cancel order' },
} satisfies Namespace;
